import { ReactNode } from "react";
import { Sidebar } from "primereact/sidebar";
import { classNames } from "primereact/utils";
import styles from "./FiltersSidePanel.module.scss";

interface IFiltersSidePanelProps {
  visible: boolean;
  onHide: () => void;
  title?: string;
  className?: string;
  /** The edge it slides in from; filters use the right one. */
  position?: "left" | "right";
  children: ReactNode;
}

/**
 * Glass side panel that hosts filters (from the right). Shared by the planner
 * calendar and by every list built on top of ItemsList, so all filter panels
 * in the app look and behave the same.
 */
export const FiltersSidePanel = ({
  visible,
  onHide,
  title = "Филтри",
  className,
  position = "right",
  children,
}: IFiltersSidePanelProps) => {
  return (
    <Sidebar
      header={<h3 className={styles.root_title}>{title}</h3>}
      visible={visible}
      className={classNames(styles.root, position === "left" && styles.root_left, className)}
      position={position}
      onHide={onHide}
    >
      {children}
    </Sidebar>
  );
};
